import React from "react";
import { useZoom } from "@/contexts/ZoomContext";
import { twClassNames } from "@scripts/react/helpers/twClassNames";
import Button from "@components/Button";
import { TooltipContainer } from "@scripts/react/components/Tooltip";

interface ZoomControlsProps {
    className?: string;
}

export const ZoomControls: React.FC<ZoomControlsProps> = ({ className }) => {
    const { zoomIn, zoomOut, resetZoom } = useZoom();

    return (
        <div className={twClassNames("pointer-events-auto flex flex-row items-center", className)}>
            <TooltipContainer
                type="titleOnly"
                title={
                    <div>
                        Zoom Out <span className="hotkey dark ml-1">⌘</span>
                        <span className="hotkey dark ml-1">-</span>
                    </div>
                }
                customButton={
                    <Button onClick={zoomOut} type="ghost" size="xsmall" shape="square">
                        <i className="fas fa-minus" />
                    </Button>
                }
            />

            <TooltipContainer
                type="titleOnly"
                title={
                    <div>
                        Zoom In <span className="hotkey dark ml-1">⌘</span>
                        <span className="hotkey dark ml-1">+</span>
                    </div>
                }
                customButton={
                    <Button onClick={zoomIn} type="ghost" size="xsmall" shape="square">
                        <i className="fas fa-plus" />
                    </Button>
                }
            />
            <TooltipContainer
                type="titleOnly"
                title="Reset Zoom"
                customButton={
                    <Button onClick={resetZoom} type="ghost" size="xsmall">
                        Reset
                    </Button>
                }
            />
        </div>
    );
};
